import React from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider } from '@material-ui/core/styles'
import { Box, Container, Typography } from '@material-ui/core'
import Cancel from '@material-ui/icons/Cancel'
import Moment from 'react-moment'
import moment from 'moment'

import AudienceAcquisitionHeaderComponent from './AudienceAcquisitionHeaderComponent'
import AudienceAcquisitionOnBoarding from './AudienceAcquisitionOnBoarding'
import AudienceLiftOnBoarding from './AudienceLiftOnBoarding'
import Spinner from '../Spinner'
import NotFound from '../NotFound'

import './AudienceAcquisitionComponent.scss'
import { theme } from '../../classes/Themes'
import { withStyles } from '@material-ui/core/styles'
import { styles } from '../../classes/Styles'
import Profile from '../../classes/profile'
import { ACQUISITION_PREMIERE, ACQUISITION_ROLLING, AUDIENCE_ACQUISITION_MODULE, AUDIENCE_LIFT_MODULE } from '../../constants/commons'
import AcquisitionRollingComponent from './AcquisitionRollingComponent'
import AcquisitionPremiereComponent from './AcquisitionPremiereComponent'

class AudienceAcquisitionComponent extends React.Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    history: PropTypes.object,
    profile: Profile.PropTypes,
    location: PropTypes.object,
    homepage: PropTypes.object,
    classes: PropTypes.object.isRequired,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string.isRequired
    }),
    audienceAcquisition: PropTypes.object,
    shortcutPreference: PropTypes.string
  }

  constructor (props) {
    super(props)

    this.state = {
      audienceAcquisition: {
        isFetching: false,
        error: null,
        selectedNetwork: ''
      },
      page: 0
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.audienceAcquisition !== this.props.audienceAcquisition) {
      this.handleChangePage(0)
    }

    if (prevProps.audienceAcquisition != this.props.audienceAcquisition && this.props.audienceAcquisition.details) {
      this.setState({ selectedNetwork: this.props.audienceAcquisition.details.audience_acquisition_network && this.props.audienceAcquisition.details.audience_acquisition_network.display_name})
    }
  }

  _renderShortcut () {
    if (!this.props.shortcut || this.state.hideShortcutBanner) {
      return null
    }

    const expires = this.props.shortcut.expires_at
    const click = e => {
      e.preventDefault()
      this.setState({ hideShortcutBanner: true })
    }

    return (
      <div className='shortCutBanner'>
        <span>
          <span>This preview of content analytics for <strong>{this.state.selectedNetwork}</strong> will expire on&nbsp;</span>
          <Moment format='MM/DD/YYYY'>{expires}</Moment>
        </span>
        <span onClick={click}><Cancel /></span>
      </div>
    )
  }

  _renderOnboarding () {
    if (!this.props.shortcut) {
      return null
    }
    if (this.props.shortcut.target === AUDIENCE_ACQUISITION_MODULE) {
      return (
        <AudienceAcquisitionOnBoarding
          name={'New Audience Drivers Tour'}
          run={true}
          selectedNetwork={this.state.selectedNetwork}
        />
      )
    } else if (this.props.shortcut.target === AUDIENCE_LIFT_MODULE) {
      return (
        <AudienceLiftOnBoarding
          name={'Audience Lift Tour'}
          run={true}
          selectedNetwork={this.state.selectedNetwork}
        />
      )
    }
  }

  setSelectedNetwork = (network) => {
    this.setState({ selectedNetwork: network })
  }

  handleChangePage = page => {
    this.setState({ page: page})
  }

  render () {
    const { history, homepage, audienceAcquisition, shortcut, profile, location } = this.props
    let pathname = this.props.location ? this.props.location.pathname : ''
    const mondayDate = moment().day('Monday').format('YYYY-MM-DD')
    const saturdayDate = moment(mondayDate).subtract(2, 'days').format('MMM DD, YYYY')
    if (this.props.homepage.isFetching) {
      return (<Spinner />)
    }

    if (this.props.homepage.error || (!this.props.homepage.isFetching && this.props.homepage.details && this.props.homepage.details.network_entities && this.props.homepage.details.network_entities.length === 0)) {
      return (<NotFound isAdmin={this.props.isAdmin}/>)
    }

    return (
      <ThemeProvider theme={theme}>
        <div className="rightSide acquisationWrap">
          <Container fluid="true" maxWidth="xl" className={this.props.classes.containerRootAA}>
            {this._renderShortcut()}
            {this._renderOnboarding()}
            <AudienceAcquisitionHeaderComponent
              homepage={this.props.homepage}
              history={this.props.history}
              shortcut={this.props.shortcut}
              setSelectedNetwork={this.setSelectedNetwork}
              audienceAcquisition={this.props.audienceAcquisition}
              pathname={pathname}
            />
            <Box className="dateTxt">
              <Typography>Data as of {saturdayDate}</Typography>
            </Box>
            { (pathname.includes(ACQUISITION_ROLLING) || (this.props.shortcut && (this.props.shortcut.target === AUDIENCE_ACQUISITION_MODULE))) &&
              <AcquisitionRollingComponent
                isAdmin={this.props.isAdmin}
                history={history}
                profile={profile}
                location={location}
                homepage={homepage ? homepage : this.props.homepage}
                shortcut={shortcut}
                audienceAcquisition={audienceAcquisition}
              />
            }
            { (pathname.includes(ACQUISITION_PREMIERE) || (this.props.shortcut && this.props.shortcut.target === AUDIENCE_LIFT_MODULE)) &&
              <AcquisitionPremiereComponent
                isAdmin={this.props.isAdmin}
                history={history}
                profile={profile}
                location={location}
                homepage={homepage ? homepage : this.props.homepage}
                shortcut={shortcut}
                audienceAcquisition={audienceAcquisition}
              />
            }
          </Container>
        </div>
      </ThemeProvider>
    )
  }
}

export default withStyles(styles)(AudienceAcquisitionComponent)
